/**
 * Barra fina de quanto (0 a 1): o uso da cota do Gemini, a nota de uma
 * escala do perfil. Neutra por padrão; o tom só quando a barra comunica um
 * estado (esgotada, perto do fim). O número sempre vai em texto ao lado.
 */
import React from "react";
import styled from "styled-components";

const Trilho = styled.span`
  display: block;
  position: relative;
  width: 100%;
  min-width: 0;
  height: 6px;
  border-radius: 3px;
  background: var(--surface-3);
  overflow: hidden;
`;

const Preenchido = styled.span`
  position: absolute;
  inset: 0 auto 0 0;
  border-radius: 3px;
  background: ${({ $tom }) => ($tom && $tom !== "neutral" ? `var(--${$tom}-solid)` : "var(--ink-3)")};
`;

function fracao(valor) {
  const n = Number(valor);
  if (!Number.isFinite(n)) return 0;
  return Math.min(1, Math.max(0, n));
}

/** `valor` de 0 a 1; `rotulo` e `texto` vão para o leitor de tela. */
export default function Medidor({ valor, tom, rotulo, texto, className }) {
  const parte = fracao(valor);
  return (
    <Trilho
      className={className}
      role="meter"
      aria-label={rotulo}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(parte * 100)}
      aria-valuetext={texto}
    >
      <Preenchido $tom={tom} style={{ width: `${parte * 100}%` }} />
    </Trilho>
  );
}
